import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';

const bulletinsStatistiquesData = [
   {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le quatrieme trimestre 2025.",
    link: "/documents/Mercuriales/REFERENTIEL_DES_PRIX_DU_QUATRIEME_TRIMESTRE_2025.pdf",
    image: 'assets/mercuriales/merciale2024T4.PNG',
    description: "La présentation d'une analyse détaillée des prix observés durant le quatrième trimestre 2025.",
    date: "2026-01-13",
  },
    {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le troisième trimestre 2025.",
    link: "/documents/Mercuriales/REFERENTIEL_TROISIEME_TRIMESTRE_2025.pdf",
    image: 'assets/mercuriales/merciale2024T4.PNG',
    description: "La présentation d'une analyse détaillée des prix observés durant le troisième trimestre 2025.",
    date: "2026-01-13",
  },
   {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le deuxième trimestre 2025.",
    link: "/documents/Mercuriales/REFERENTIEL_DEUXIEME_TRIMESTRE_2025_VF.pdf",
    image: 'assets/mercuriales/merciale2024T4.PNG',
    description: "La présentation d'une analyse détaillée des prix observés durant le deuxième trimestre 2025.",
    date: "2025-09-01",
  },
   {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le premier trimestre 2025.",
    link: "/documents/Mercuriales/PUBLICATION-REFERENTIEL-PREMIER-TRIMESTRE-2025.pdf",
    image: 'assets/mercuriales/merciale2024T4.PNG',
    description: "La présentation d'une analyse détaillée des prix observés durant le premier trimestre 2025.",
    date: "2025-06-01",
  },
  {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le quatrieme trimestre 2024.",
    link: "/documents/Mercuriales/PUBLICATION-REFERENTIEL-DEC-2024_vf2.pdf",
    image: 'assets/mercuriales/merciale2024T4.PNG',
    description: "La présentation d'une analyse détaillée des prix observés durant le quatrieme trimestre 2024.",
    date: "2025-02-01",
  },
  {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le troisième trimestre 2024.",
    link: "/documents/Mercuriales/PUBLICATION-REFERENTIEL-DU-TROISIEME-TRIMESTRE-2024.pdf",
    image: 'assets/mercuriales/mercuriale_2024_3tr.PNG',
    description: "La présentation une analyse détaillée des prix observés durant le troisième trimestre 2024.",
    date: "2024-11-01" 
  },
  {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le deuxième trimestre 2024.",
    link: "/documents/Mercuriales/Referentiel_deuxieme_trimestre2024.pdf",
    image: 'assets/mercuriales/mercuriale_2024_2tr.PNG',
    description: "La présentation des prix moyens pour le deuxième trimestre 2024.",
    date: "2024-04-01",
  },
  {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le premier trimestre 2024.",
    link: "/documents/Mercuriales/Referentiel-des-prix-premier-trimestre-2024v2.pdf",
    image: 'assets/mercuriales/mercuriale_2024_1tr.PNG',
    description: "La présentation des prix du premier trimestre 2024.",
    date: "2024-01-01", 
  },
  {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le troisième trimestre 2023.",
    link: "/documents/Mercuriales/Referentiel-des-prix-troisieme-trimestre-2023.pdf",
    image: 'assets/mercuriales/mercuriale_2023_3tr.PNG',
    description: "L'Analyse des prix pour le troisième trimestre 2023.",
    date: "2023-07-01",
  },
  {
    title: "Le référentiel (mercuriale) des prix du Burundi pour le deuxième trimestre 2023.",
    link: "/documents/Mercuriales/Referentiel-des-prix-du-deuxieme-trimestre-2023_modifie_19.07.2023.pdf",
    image: 'assets/mercuriales/mercuriale_2023_2tr.PNG',
    description: "La présentation des prix pour le deuxième trimestre 2023.",
    date: "2023-04-01",
  },
  {
    title: "Le référentiel (mercuriale) des prix du Burundi pour l'année 2022.",
    link: "/documents/Mercuriales/Mercuriale-des-prix-du-Burundi-Annee-2022.pdf",
    image: 'assets/mercuriales/mercuriale_2022.PNG',
    description: "La présentation des prix de tous les trimestres de l'année 2022.",
    date: "2022-12-31",
  }
];

function Mercuriale() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsStatistiquesData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredBulletins(bulletinsStatistiquesData.sort((a, b) => new Date(b.date) - new Date(a.date)));
    } else {
      const filtered = bulletinsStatistiquesData.filter((bulletin) => {
        const bulletinYear = new Date(bulletin.date).getFullYear();
        return bulletinYear === parseInt(year);
      });
      setFilteredBulletins(filtered.sort((a, b) => new Date(b.date) - new Date(a.date)));
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      secondary: {
        main: '#673AB7',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h6: {
        fontWeight: '500',
        fontSize: '1rem',
        textTransform: 'none',
        color: '#3B3F54'
      },
      body2: {
        fontSize: 14,
        letterSpacing: 0.25,
        color: '#6B778C',
      },
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: '500',
            padding: '10px 20px',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
            '&:hover': {
              transform: 'scale(1.05)',
              boxShadow: '0px 12px 20px rgba(0, 0, 0, 0.15)',
            },
            borderRadius: '8px',
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          h6: {
            fontWeight: '500',
            fontSize: '1rem'
          },
          h4: {
            fontWeight: '600',
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            marginBottom: '16px',
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '64px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Référentiel des prix au Burundi
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            cette section présente les prix moyens de 1 183 articles issus de divers marchands et entreprises situés dans la Mairie de Bujumbura. Ce recueil de données comprend une large gamme de produits, englobant aussi bien des biens alimentaires que non alimentaires, utilisés couramment par les administrations publiques. 
          </Typography>
          <FormControl fullWidth variant="outlined"  style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année de publication"
            >
              <MenuItem value="Tous">Tous les référentiels</MenuItem>
              {[...new Set(bulletinsStatistiquesData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          {/* Affichage des bulletins */}
          <Grid container spacing={1} style={{ marginTop: '20px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <CardMedia
                      component="img"
                      sx={{ width: 61, height: 100, m: 2, cursor: 'pointer' }}
                      image={bulletin.image}
                      alt={bulletin.title}
                      onClick={() => window.open(bulletin.link, '_blank')} 
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', color: 'green', marginBottom: '10px', cursor: 'pointer' }} onClick={() => window.open(bulletin.link, '_blank')}>
                      {<DownloadIcon />}{bulletin.title}
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {bulletin.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(bulletin.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
                marginBottom: '20px',
              }}
            >
              Plus de référentiels
            </Button>
          )}

          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
            <strong>Note :</strong> Les référentiels des prix au Burundi sont publiés trimestriellement, généralement <strong>45 jours</strong> après la fin de chaque trimestre, ce qui correspond aux dates suivantes :
            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
              <li><strong>15 février</strong> - Fin du quatrième trimestre </li>
              <li><strong>15 mai</strong> - Fin du premier trimestre </li>
              <li><strong>15 août</strong> - Fin du deuxième trimestre </li>
              <li><strong>15 novembre</strong> - Fin du troisième trimestre</li>
            </ul>
          </Typography>
        </Container>
      </div>
      <Footer />
    </ThemeProvider>
  );
}

export default Mercuriale;